// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import store from './store'

import echarts from 'echarts'


Vue.prototype.$echarts = echarts;

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'babel-polyfill'
import layer from 'vue-layer'



// import 'lib-flexible'
Vue.prototype.$layer = layer(Vue, {
    msgtime: 100 //默认消失时间 单位：秒
});

Vue.use(ElementUI);

Vue.use(Vuex);
Vue.config.productionTip = false;


/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
});


// WEBPACK FOOTER //
// ./src/main.js